export default function PHP_getMessage() {
  return (
    <div>
      <h1>PHP_getMessage</h1>
    </div>
  );
}
